export default "__VITE_ASSET__8h9ZSm4f__"